import { NgModule }     from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2BootstrapModule } from 'ngx-bootstrap';

import { FormatterDirective } from './dynamic/formatting.directive';
import { TextMaskModule } from 'angular2-text-mask';
import {
  DynamicFormComponent,
  DynamicFormQuestionComponent
} from './dynamic/index';

@NgModule({
  imports: [
    CommonModule,
    TextMaskModule,
    Ng2BootstrapModule.forRoot(),
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    FormatterDirective,
    DynamicFormComponent,
    DynamicFormQuestionComponent,
  ],
  exports: [
    DynamicFormComponent,
    FormatterDirective
  ]
})
export class DynamicForm {}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
